import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { BaseEntity } from './BaseEntity'

/**
 * 圆实体，由圆心与半径定义。
 */
export class CircleEntity extends BaseEntity {
  /** 圆心 */
  center!: IPoint
  /** 半径，单位米 */
  radius!: number

  /** 渲染采样段数，不参与序列化 */
  segmentsNum?: number

  protected readonly serializeKeys: string[] = ['center', 'radius']

  constructor(data: Partial<CircleEntity>) {
    super(EntityType.Circle)
    Object.assign(this, data)
  }

  /**
   * 获取捕捉数据，返回圆心。
   *
   * 圆的线段捕捉较复杂，暂不实现。
   *
   * @returns 仅包含圆心的捕捉数据
   */
  getCaptureData() {
    return {
      centerPoints: [
        // 圆心
        { x: this.center.x, y: this.center.y },
      ],
    }
  }
}
